export default function({ backgroundColor, rootHeight, rootWidth }) {
  return {
    backgroundColor,
    height: rootHeight,
    width: rootWidth
  };
}
